import { apiOfficialClient } from './config.js';

export default {
  getSurveys(token) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiOfficialClient.get(`surveys/`);
  },
  sendSurvey(token, survey) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiOfficialClient.post(`send_surveys/`, survey);
  },
};
